import { useMemo } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { resolveTz } from '../utils/dateFormatters';

export function useTimezone(): string {
  const { profile } = useProfile();
  return useMemo(() => resolveTz(profile?.time_zone), [profile?.time_zone]);
}
